import React, { useContext, useEffect, useState } from 'react';
import Styled from './AdminEditor.styled';

import { GradientButton, RedSolidButton } from 'components/UI/Buttons';
import AdminHomeConteudoService from 'core/http/service/admin/AdminHomeConteudo.service';

import AdminImageUploader from '../imageUploader/AdminImageUploader';
import { isStringsValid, isValidLink } from './isValidNewContentInput';
import { Form } from 'react-bootstrap';
import AdminSecaoPaginaData, { AdminSecaoPaginaBanner } from 'pages/gestao_paginas/AdminSecaoPaginaData';
import { AdminGestaoPaginasContext } from 'pages/gestao_paginas/context/AdminGestaoPaginasContext';
import { AdminGestaoPaginasMode } from 'pages/gestao_paginas/AdminGestaoPaginasContextWrapper';
import AdminGestaoPaginaService from 'core/http/service/admin/AdminGestaoPagina.service';
import { ToastError, ToastSuccess } from 'components/Toaster';
import { useHistory, useParams } from 'react-router-dom';
import Loading from 'components/Loading';
import AllowedGroupsValidator from 'pages/admin/components/allowedGroupsValidator/AllowedGroupsValidator';
import { KcAdminGroups } from 'models/kc/KcUserInfo';
import ModalExclusao from 'pages/gestao_paginas/new-edit-recurso/components/modal/ModalExclusao';
import TipoRedirecionamento from 'enums/TipoRedirecionamento';
import Select from 'components/Select';
import { getOptionFromValue, tipoRedirecionamentoOptions } from './tipoRedirecionamento';

export interface IAdminEditSection {
    onSaved: (secao: AdminSecaoPaginaData) => void;
    onUpdate: (secao: AdminSecaoPaginaData) => void;
    onDelete: () => void;
    mode?: AdminGestaoPaginasMode;
    custom?: boolean;
}

const AdminEditBanner = ({ onSaved, mode, onUpdate, onDelete }: IAdminEditSection) => {
    const history = useHistory();
    const params: any = useParams();
    const [cover, setCover] = useState<string | null>(null);
    const [idSecao, setIdSecao] = useState<number>(0);
    const [title, setTitle] = useState('');
    const [text, setText] = useState('');
    const [texto_botao_a, setTextoBotaoA] = useState('');
    const [texto_botao_b, setTextoBotaoB] = useState('');
    const [link_interno, setLinkInterno] = useState('');
    const [paginaLateral, setPaginaLateral] = useState(false);
    const [tipoRedirecionamento, setTipoRedirecionamento] = useState<TipoRedirecionamento>(TipoRedirecionamento.LOGIN);
    const [loading, setloading] = useState(false);
    const [modePage, setModePage] = useState<boolean>(false);

    const [isLoadingDelete, setIsLoadingDelete] = useState<boolean>(false);
    const [showModalDeleteSecao, setShowModalDeleteSecao] = useState(false);

    const [submitting, setSubmitting] = useState(false);

    const service = new AdminGestaoPaginaService();

    const MAX_CHAR_CONTENT = 1000;

    const { currentSection } = useContext(AdminGestaoPaginasContext.Context);

    const isValidInputs = (): boolean => {
        if (!cover) return false;
        return isStringsValid([title, text, texto_botao_a, link_interno]) && isValidLink(link_interno, false);
    };

    const saveSection = async (section: AdminSecaoPaginaData, holder: AdminSecaoPaginaBanner) => {
        if (!section) {
            alert('Erro ao salvar!');
            return;
        }

        const { status, data } = await service.inserirSecao(holder, section.paginaId, section.ordem);

        if (status < 300) {
            section.setCodigo(data.codigo);
            setModePage(true);
            onSaved(section);
        } else {
            ToastError('Houve um erro ao tentar salvar o seção!');
        }
    };

    const updateSection = async (section: AdminSecaoPaginaData, holder: AdminSecaoPaginaBanner) => {
        if (!section) {
            alert('Erro ao atualizar!');
            return;
        }

        const { status, data } = await service.atualizarBanner(section.codigo, holder);

        if (status < 300) {
            section.setCodigo(data.codigo);
            onUpdate(section);
        } else {
            ToastError('Houve um erro ao tentar atualizar o seção!');
        }
    };

    const submit = async () => {
        if (!currentSection) {
            alert('Seção não encontrada');
            return;
        }

        setSubmitting(true);

        const holder = currentSection?.modelData as AdminSecaoPaginaBanner;

        holder.titulo = title;
        holder.descricao = text;
        holder.textoBotaoA = texto_botao_a;
        holder.textoBotaoB = texto_botao_b;
        holder.link = link_interno;
        holder.paginaLateral = paginaLateral;
        holder.anexoBase64 = cover;
        holder.tipoRedirecionamento = tipoRedirecionamento;

        if (mode == 'NEW') {
            await saveSection(currentSection, holder);
        } else {
            console.log('entrou atualizar');
            await updateSection(currentSection, holder);
        }

        setSubmitting(false);
    };

    const fetchItem = async () => {
        if (mode == 'EDIT') {
            setloading(true);
            const id = String(params.id);
            const { data } = await service.buscaSecaoBannerPorId(parseInt(id));
            setIdSecao(parseInt(id));
            setText(data.descricao);
            setTitle(data.titulo);
            setPaginaLateral(data.paginaLateral);
            setLinkInterno(data.link);
            setTextoBotaoA(data.textoBotaoA);
            setTextoBotaoB(data.textoBotaoB);
            setCover(data.anexoBase64);
            setTipoRedirecionamento(data.tipoRedirecionamento);
            setloading(false);
            setModePage(true);
        }
    };

    useEffect(() => {
        fetchItem();
    }, []);

    const handleDelete = async () => {
        setShowModalDeleteSecao(true);
        setIsLoadingDelete(true);

        try {
            const response = await service.deleteBanner(idSecao);

            if (response.status === 200) {
                ToastSuccess('Banner excluído com sucesso!');
                setShowModalDeleteSecao(false);
                setIsLoadingDelete(false);
                onDelete();
            }
        } catch (error) {
            ToastError('Ocorreu um erro na hora da exclusão.');
        }
    };

    return (
        <Styled.Container>
            <ModalExclusao
                showModal={showModalDeleteSecao}
                handleHiden={setShowModalDeleteSecao}
                handleExcluxed={handleDelete}
                isLoading={isLoadingDelete}
            />
            {!loading ? (
                <>
                    <div>
                        <AdminImageUploader
                            onSelect={() => {}}
                            setBase64={b => setCover(b)}
                            size={'lg'}
                            title={'Imagem do topo'}
                            preImageB64={cover}
                            recommendedDimension={!paginaLateral ? { w: 1524, h: 660 } : { w: 439, h: 470 }}
                        />

                        <Styled.Label>Layout banner</Styled.Label>
                        <Styled.CkeckContainer>
                            <Form.Check
                                id="radio-banner-lateral"
                                checked={paginaLateral}
                                type="radio"
                                aria-label="radio 1"
                                onChange={() => setPaginaLateral(true)}
                            />
                            <label htmlFor={`radio-banner-lateral`} style={{ marginRight: '10px' }}>
                                Lateral
                            </label>
                            <Form.Check
                                id="radio-interno-completo"
                                checked={!paginaLateral}
                                type="radio"
                                aria-label="radio 2"
                                onChange={() => setPaginaLateral(false)}
                            />
                            <label htmlFor={`radio-interno-completo`}>Completo</label>
                        </Styled.CkeckContainer>

                        <Styled.Label>Título</Styled.Label>
                        <Styled.Input value={title} onChange={(evt: any) => setTitle(evt.target.value)} />

                        <Styled.Label>Texto</Styled.Label>
                        <Styled.Input
                            value={text}
                            onChange={(evn: any) => setText(evn.target.value)}
                            rows={8}
                            as="textarea"
                            className={'form-control'}
                            maxLength={MAX_CHAR_CONTENT}
                        />
                        <Styled.CountLetter danger={text.length >= MAX_CHAR_CONTENT}>
                            {text.length}/{MAX_CHAR_CONTENT}
                        </Styled.CountLetter>

                        <Styled.Label>Texto Botão</Styled.Label>
                        <Styled.Input value={texto_botao_a} onChange={(evt: any) => setTextoBotaoA(evt.target.value)} />

                        {/*<Styled.Label>Texto Botão</Styled.Label>
                        <Styled.Input value={texto_botao_b} onChange={(evt: any) => setTextoBotaoB(evt.target.value)} />*/}

                        <Styled.Label>Link Botão</Styled.Label>
                        <Styled.Input
                            className={link_interno.length > 0 && !isValidLink(link_interno, false) && 'is-invalid'}
                            value={link_interno}
                            onChange={(evt: any) => setLinkInterno(evt.target.value)}
                        />
                        <Styled.SubLabel>
                            OBS: Para redirecionar o usuário para os <strong>links externos</strong>, é necessário seguir o padrão:{' '}
                            <strong>http://url</strong>
                            ou <strong>https://url</strong>. Para <strong>links internos</strong>, temos dois exemplos de opções:
                            <strong>http://ambiente/recursos/trilhas</strong>
                            ou <strong>/recursos/trilhas</strong>.
                        </Styled.SubLabel>

                        <Styled.Label>Tipo de redirecionamento</Styled.Label>
                        <Select
                            isSmall
                            value={getOptionFromValue(tipoRedirecionamento)}
                            itens={tipoRedirecionamentoOptions}
                            onSelected={o => setTipoRedirecionamento(o.value as TipoRedirecionamento)}
                        />
                        <Styled.SubLabel>
                            {`OBS: A opção "Tipo de Redirecionamento" foi projetada para uso em páginas que não possuem validação automática,
                            redirecionando o usuário para login ou cadastro caso ele esteja deslogado. Portanto, o comportamento pode variar caso
                            ele seja usado em fluxos que já são automatizados.`}
                        </Styled.SubLabel>
                    </div>

                    <Styled.RigthArea>
                        {modePage && (
                            <AllowedGroupsValidator allowedGroups={[KcAdminGroups.MASTER]}>
                                <RedSolidButton style={{ marginBottom: 20 }} onClick={() => setShowModalDeleteSecao(true)}>
                                    Deletar
                                </RedSolidButton>
                            </AllowedGroupsValidator>
                        )}
                        <GradientButton disabled={submitting || !isValidInputs()} onClick={submit}>
                            {submitting ? 'Salvando...' : 'Salvar'}
                        </GradientButton>
                    </Styled.RigthArea>
                </>
            ) : (
                <Loading />
            )}
        </Styled.Container>
    );
};

export default AdminEditBanner;
